import { Component } from '@angular/core';
import { ElementRef, HostListener } from '@angular/core';

import type { IHeaderParams } from 'ag-grid-community';
import { GridApi } from 'ag-grid-community';

/**
 * Renders a grid options menu column header cell.
 */
@Component({
	selector: 'grid-tools-header-renderer',
	templateUrl: './grid-tools-header-renderer.component.html',
	styleUrl: './grid-tools-header-renderer.component.css'
})
export class GridToolsHeaderRendererComponent {

	params!: IHeaderParams;
	gridApi!: GridApi;

	allColumns: any[] = [];
	showSelector = false;

	constructor(
		private eRef: ElementRef
	) { }

	agInit(params: IHeaderParams): void {
		this.params = params;
		this.gridApi = params.api!;
		
		this.allColumns = this.gridApi.getAllGridColumns()
			.filter((col: any) => {
				const field = col.getColDef().field;
				return field 
				&& field !== 'id' 
				&& field !== '_icons'
				&& field !== '_buttons';
			});
	}

	refresh(params: IHeaderParams): boolean {
		this.params = params;
		return true;
	}

	toggleSelector() {
		this.showSelector = !this.showSelector;
	}

	toggleColumn(colId: string, event: Event) {
		const input = event.target as HTMLInputElement;
		const visible = input.checked;
		this.gridApi.setColumnsVisible([colId], visible);
	}

	@HostListener('document:click', ['$event'])
	handleClickOutside(event: MouseEvent) {
		if (!this.eRef.nativeElement.contains(event.target)) {
			this.showSelector = false;
		}
	}
}
